import React from 'react';
import * as PropTypes from 'prop-types';
import {convertIntoCurencyValue} from './input-logic';
import {BasicNumberInput} from './basic-number-input';

export const CurrencyInput = ({
	value,
	placeholder,
	disabled,
	hasError,
	onClick,
	onBlur,
	onChange,
	callback,
	currencySymbole,
	width,
	showAsterisk,
	cy,
	modalView,
	alignLeft,
	forceUpdate,
	taskModalStyle,
	innerRef,
	intl,
	maxLength,
	filterNonNumerics,
	label,
	autoFocus,
	className,
	noBorder,
	noLocked,
}) => {
	return (
		<BasicNumberInput
			placeholder={placeholder}
			showAsterisk={showAsterisk}
			value={value}
			hasError={hasError}
			onClick={onClick}
			onBlur={onBlur}
			onChange={onChange}
			disabled={disabled}
			converterValue={(value, specialRule, showAsterisk) =>
				convertIntoCurencyValue(value, currencySymbole, specialRule, showAsterisk, intl, maxLength)
			}
			numberSymbol={currencySymbole}
			callback={callback}
			width={width}
			cy={cy}
			modalView={modalView}
			alignLeft={alignLeft}
			forceUpdate={forceUpdate}
			taskModalStyle={taskModalStyle}
			innerRef={innerRef}
			filterNonNumerics={filterNonNumerics}
			label={label}
			autoFocus={autoFocus}
			className={className}
			noBorder={noBorder}
			noLocked={noLocked}
		></BasicNumberInput>
	);
};

CurrencyInput.propTypes = {
	/**
	 
	 */
	showAsterisk: PropTypes.bool,
	/**
	 * Information when no value has been set yet.
	 */
	placeholder: PropTypes.string,
	/**
	 * Disable the input the user can't insert a new value or edit the current one.
	 */
	disabled: PropTypes.bool,
	/**
	 * When the input is focused the current value is selected. And the cursor ready to receive text input
	 */
	onClick: PropTypes.func,
	/**
	 * On blue the input parse the value to change it to the hours format (1h 30m).
	 * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
	 */
	onBlur: PropTypes.func,
	/**
	 * Indicator to show that the input is in an invalid state
	 */
	hasError: PropTypes.bool,
	/**
	 * Don't show border in invoice entry number fields
	 */
	noBorder: PropTypes.bool,
	/**
	 * Don't lock invoice entry number fields
	 */
	noLocked: PropTypes.bool,
	/**
	 * Action to execute if the validation is successful
	 */
	callback: PropTypes.func,
	/**
	 * Value of the input
	 */
	value: PropTypes.any,
	/**
	 * Symoble of currency to display
	 */
	currencySymbole: PropTypes.string.isRequired,

	/**
	 * Width of the input
	 */
	width: PropTypes.string,

	onChange: PropTypes.func,
	cy: PropTypes.string,
	modalView: PropTypes.bool,
	alignLeft: PropTypes.bool,
	/**
	 * Flag to force the input to re render
	 */
	forceUpdate: PropTypes.any,

	/**
	 * Specific styling for the input in the task modal
	 */
	taskModalStyle: PropTypes.bool,

	/**
	 * Ref to the input
	 */
	innerRef: PropTypes.object,

	intl: PropTypes.shape({
		formatNumber: PropTypes.func,
	}),

	maxLength: PropTypes.number,

	/**
	 * filter non numeric characters from input
	 */
	filterNonNumerics: PropTypes.bool,

	/**
	 * Label for input
	 */
	label: PropTypes.string,

	/**
	 * autoFocus the input
	 */
	autoFocus: PropTypes.bool,

	className: PropTypes.string,
};

CurrencyInput.defaultProps = {
	disabled: false,
	hasError: false,
	intl: {
		formatNumber: ({value}) => value,
	},
};
